import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { Clock, CheckCircle2 } from "lucide-react";

/**
 * SetupBadge — shows "Setup pending" until the relevant admin integration is configured.
 * Disappears automatically once admin enters keys + enables the gateway in /app/admin → Payments.
 *
 * type: "payments" | "razorpay" | "stripe"
 * country: optional ISO code (defaults to "IN" for razorpay-aware checks)
 */
export default function SetupBadge({ type = "payments", country = "IN", showWhenConfigured = false, className = "" }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    axios.get(`${API}/payments/public-config`, { params: { country } }).then(r => setCfg(r.data)).catch(() => setCfg({ configured: false, gateway: "mock" }));
  }, [country]);

  if (!cfg) return null;

  const isConfigured = type === "razorpay"
    ? cfg.gateway === "razorpay" && cfg.configured
    : type === "stripe"
      ? cfg.gateway === "stripe" && cfg.configured
      : cfg.configured;

  if (isConfigured) {
    if (!showWhenConfigured) return null;
    return (
      <span className={`inline-flex items-center gap-1 bg-leaf/30 text-ink px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${className}`} data-testid={`setup-badge-ready-${type}`}>
        <CheckCircle2 className="w-3 h-3"/> Ready
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 bg-sunshine/40 text-ink px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${className}`} data-testid={`setup-badge-pending-${type}`}>
      <Clock className="w-3 h-3"/> Setup pending
    </span>
  );
}
